import type { ThemeToggleContent } from "../types";

export const themeToggle: ThemeToggleContent = {
  toLight: "Switch to light theme",
  toDark: "Switch to dark theme",
};
